module.exports = __webpack_public_path__ + "img/jiaoxue_3dbase_img.033a8b28.png";